/**
 * Sizing base unit
 * We have defined taxonomy in our CSS sizing framework instead of using pixel sizes directly.
 * This base unit tells how much pixels it is based on.
 * https://design-system.protontech.ch/?path=/docs/css-utilities-sizing--fractions#framework
 */
export const CSS_BASE_UNIT_SIZE = 4;
